import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { TituloI } from "interfaces/Titulo";
import { Dropdown } from "react-bootstrap";
import { deleteTitulo } from "services/titulos";

interface Props {
  elemento: TituloI;
  onClickEdit: (elemento: TituloI) => void;
  refreshTable: () => void;
}

export const TitulosRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteTitulo(id);
      showSuccessToast("¡El título fue eliminado con éxito!");
      refreshTable();
    } catch (error) {
      showErrorToast("Error eliminando el título");
    }
  };

  // const onClickVerDocumento = (id: string | number) => {
  //     openFile({ id })
  // }

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar resolución"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar el Título {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
